import { render, staticRenderFns } from "./automationPermissionListField.vue?vue&type=template&id=185ab9d7&"
import script from "./automationPermissionListField.vue?vue&type=script&lang=js&"
export * from "./automationPermissionListField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports